import {
    SaveSoundboardConfigRequest,
    SoundItemMap,
} from "@lifeat/shared/data-models/widget/Soundboard/SoundboardDataModels";
import { functions } from "@firebase-local/firebase";
import { SOUNDBOARD_WIDGET_FUNCTIONS } from "@firebase-local/functions/ServerlessEndpoints";
import { logError } from "@service/ConsoleLoggerService";

export const fetchPremiumSounds = (uid: string, callback: (data: SoundItemMap) => void) => {
    functions
        .httpsCallable(SOUNDBOARD_WIDGET_FUNCTIONS.FetchPremiumSounds)()
        .then((result) => {
            if (result.data) {
                callback(result.data);
            }
        })
        .catch((error) => {
            logError(error);
        });
};

export const saveSoundsOrderForUser = (soundsOrder: string[]) => {
    const reqData: SaveSoundboardConfigRequest = {
        soundsOrder: soundsOrder,
    };
    functions
        .httpsCallable(SOUNDBOARD_WIDGET_FUNCTIONS.SaveSoundsOrder)(reqData)
        .then((result) => {})
        .catch((error) => {
            logError(error);
        });
};
